module.exports = __webpack_public_path__ + "img/people-33.d553cc69.png";